
import { Component, Vue } from "vue-property-decorator";
import {
  getClaimReason,
  getClaimBaseFiles,
  uploadClaimBaseFiles,
  deleteClaimFile,
  getDeductionDetails,
  getWriteOffDetails,
  downloadClaimFormInfo,
  abolished,
  updateClaimRemark,
  claimSearch, getDeductionMethod, claimDetail,
} from "@/api/credit-note";
import Pagination from "@/components/Pagination/index.vue";
import { getSuppliersList, getSalesmanList } from "@/api/inquiry";
import { getPiClaimType } from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { getUsersByJobPosition } from "@/api/users";
import EditClaimForm from "@/views-oms/credit-note-management/claim-management/components/EditClaimForm.vue";
import ClaimFormDetail from "@/views-oms/credit-note-management/claim-management/components/ClaimFormDetail.vue";

@Component({
  name: "ClaimDetails",
  components: {
    EditClaimForm,
    ClaimFormDetail,
    Pagination,
    Verification: () =>
      import(
        "@/views-oms/purchase-order-management/claims/components/verification/indexOfClaim.vue"
      ),
  },
})
export default class extends Vue {
  private isShowMore = false;
  private isShowMore2 = false;
  private showVer = false;
  private showHXDetails = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public AnnexList = [] as any;
  public AnnexCol = [
    {
      label: "文件名",
      prop: "fileName",
      key: "fileName",
      show: true,
      disabled: false,
    },
    {
      label: "操作时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
    {
      label: "上传用户",
      prop: "uploader",
      key: "uploader",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      show: true,
      disabled: false,
      type: "actions",
      options: [
        {
          name: "替换",
          code: "",
          click: "handleDeduction",
        },
        {
          name: "删除",
          code: "",
          type: "delete",
          click: "handleDeleteFiles",
        },
      ],
      width: 210,
    },
  ];
  public info = { allAmount: 0 } as any;
  public infoFields = [
    {
      label: "CreditNote编号",
      key: "code",
    },
    {
      label: "CreditNote状态",
      key: "status",
    },
    {
      label: "客人简称",
      key: "customer",
    },
    {
      label: "索赔总金额",
      key: "allAmount",
    },
    {
      label: "提交时间",
      key: "issuedDate",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  public listParam = {
    creditNoteId: null,
    claimFormCode: null,
    supplierId: null,
    purchaser: null,
    purchaseOrder: null,
    status: null,
    claimReason: null,
    deductionMethod: null,
  };
  private showAnnex = false;
  public searchForm = [
    {
      label: "供应商索赔单号",
      prop: "claimFormCode",
      key: "claimFormCode",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号",
    },
    {
      label: "供应商名称",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "采购订单号",
      prop: "purchaseOrder",
      key: "purchaseOrder",
      type: "input",
      value: "",
      placeholder: "请输入采购订单号",
    },
    {
      label: "索赔状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "索赔原因",
      prop: "claimReason",
      key: "claimReason",
      type: "cascader",
      value: "",
      placeholder: "全部",
      clearable: true,
      options: [],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "抵扣方式",
      prop: "deductionMethod",
      key: "deductionMethod",
      type: "select",
      value: "",
      placeholder: "全部",
      clearable: true,
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "供应商索赔单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "供应商名称",
      prop: "supplierName",
      key: "supplierName",
      // type: "link",
      show: true,
      disabled: false,
    },
    {
      label: "CN号码",
      prop: "creditNoteCode",
      key: "creditNoteCode",
      // type: "link",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
      show: true,
      disabled: false,
    },
    {
      label: "索赔产品",
      prop: "claimProducts",
      key: "claimProducts",
      show: true,
      disabled: false,
    },
    {
      label: "索赔数量",
      prop: "claimNumber",
      key: "claimNumber",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单金额",
      prop: "purchaseOrderAmount",
      key: "purchaseOrderAmount",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "索赔金额",
      prop: "claimAmount",
      key: "claimAmount",
      show: true,
      disabled: false,
    },
    {
      label: "索赔原因",
      prop: "claimReason",
      key: "claimReason",
      show: true,
      disabled: false,
    },
    {
      label: "抵扣方式",
      prop: "deductionMethod",
      key: "deductionMethod",
      show: true,
      disabled: false,
    },
    {
      label: "索赔抵扣",
      prop: "claimDeduction",
      key: "claimDeduction",
      show: true,
      disabled: false,
    },
    {
      label: "索赔单状态",
      prop: "status",
      key: "status",
      type: "actions",
      options: [
        {
          name: "待抵扣",
          code: "",
          click: "handleDeductionToFa",
          key: "status",
          value: "待抵扣",
        },
        {
          name: "部分抵扣",
          code: "",
          click: "handleDeductionToFa",
          key: "status",
          value: "部分抵扣",
        },
        {
          name: "被核销",
          code: "",
          click: "handleDeductionToQa",
          key: "status",
          value: "被核销",
        },
        {
          name: "待生成索赔单",
          code: "",
          type: "none",
          key: "status",
          value: "待生成索赔单",
        },
        {
          name: "已完成",
          code: "",
          click: "handleDeduction",
          key: "status",
          value: "已完成",
        },
        {
          name: "已作废",
          code: "",
          type: "none",
          key: "status",
          value: "已作废",
        },
      ],
      show: true,
      disabled: false,
      width: 130,
    },
    {
      label: "索赔损耗",
      prop: "claimLosses",
      key: "claimLosses",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "采购订单号",
      prop: "purchaseOrders",
      key: "purchaseOrders",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      length: 255,
    },
    {
      label: "签发时间",
      prop: "timeOfIssue",
      key: "timeOfIssue",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "生成索赔单",
          code: "",
          click: "handleGeneral",
          key: "status",
          value: "待生成索赔单",
        },
        {
          name: "编辑",
          code: "",
          click: "handleEdit",
          key: "status",
          value: "待抵扣",
        },
        {
          name: "索赔单详情",
          code: "",
          click: "handleClaimDet",
          key: "status",
          value: "待抵扣,部分抵扣,已完成,被核销",
        },
        {
          name: "下载产品清单",
          code: "",
          click: "handledownloadClaimFormInfo",
        },
        {
          name: "附件管理",
          code: "",
          click: "handleAnnex",
        },
        {
          name: "作废",
          code: "",
          click: "abolished",
          key: "status",
          value: "待生成索赔单",
        },
      ],
      show: true,
      disabled: false,
      width: 400,
    },
  ] as any;
  private showFileList = false;
  private files: File[] = [];
  private Annex_fa_id = "";
  private showDeductionInfo = false;
  private DeductionList = [] as any;
  private DeductionCol = [
    {
      label: "单据号码",
      prop: "relationDocumentCode",
      key: "relationDocumentCode",
      show: true,
      disabled: false,
    },
    {
      label: "单据类型",
      prop: "relationDocumentType",
      key: "relationDocumentType",
      show: true,
      disabled: false,
    },
    {
      label: "抵扣额",
      prop: "deductionAmount",
      key: "deductionAmount",
      show: true,
      disabled: false,
    },
    {
      label: "时间",
      prop: "createdTime",
      key: "createdTime",
      show: true,
      disabled: false,
    },
  ];
  private HXDetailsList = [
    {
      label: "原索赔金额",
      key: "olaAmount",
    },
    {
      label: "核销金额",
      key: "Amount",
    },
    {
      label: "核销原因",
      key: "remark",
    },
  ];

  private HXDetailsInfo = {
    olaAmount: "",
    Amount: "",
    remark: "",
  };

  private exportClaimFormInfoHeader = [
    {
      label: "claimFormId",
      key: "claimFormId",
    },
    {
      label: "客人号码",
      key: "customerNumber",
    },
    {
      label: "ref",
      key: "refNumber",
    },
    {
      label: "华强交易号码",
      key: "hqTransactionNumber",
    },
    {
      label: "OE号码",
      key: "oeNumber",
    },
    {
      label: "quantity",
      key: "quantity",
    },
    {
      label: "IV号码",
      key: "ivCode",
    },
    {
      label: "PI号码",
      key: "piNumber",
    },
    {
      label: "PO号码",
      key: "poNumber",
    },
    {
      label: "采购订单号",
      key: "purchaseOrder",
    },
    {
      label: "生产批次号",
      key: "batchNumber",
    },
    {
      label: "供应商简称",
      key: "supplierAbbreviation",
    },
    {
      label: "采购单价",
      key: "purchaseUnitPrice",
    },
    {
      label: "索赔预期",
      key: "claimExpectation",
    },
    {
      label: "备注",
      key: "remark",
    },
  ];

  created() {
    this.listParam.creditNoteId = this.$route.query.id;
    this.info.code = this.$route.query.code;
    this.info.allAmount = this.$route.query.claimAmount ? this.$route.query.claimAmount : 0;
    this.info.customer = this.$route.query.customer
      ? this.$route.query.customer
      : "";
    this.info.issuedDate =
      this.$route.query.issuedDate === undefined
        ? this.$route.query.issuedDate
        : "";
    this.info.remark = this.$route.query.remark === undefined ? this.$route.query.remark : "";
    this.info.status = this.$route.query.status ? this.$route.query.status : "";
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getSalesmanList();
    this.getClaimReason();
    this.getDeductionMethod();
    this.getCompensation();
    this.getList();
  }

  private addFile(file: File) {
    this.files.push(file);
  }

  private uploadFuJian() {
    this.$refs["uploadPL"]["$refs"]["upload-inner"].handleClick();
  }

  private handleTiHuan(row) {
    this.$refs["uploadPL"]["$refs"]["upload-inner"].handleClick();
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadJieKou(formData) {
    await uploadClaimBaseFiles(this.Annex_fa_id, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getFileList(this.Annex_fa_id);
  }

  private async getFileList(id) {
    this.loading = true;
    await getClaimBaseFiles(id).then((res:any) => {
      this.AnnexList = res;
      this.loading = false;
    }).catch(err => {
      this.loading = false
      console.log(err);
    });
  }

  private async handleAnnex(row) {
    this.showAnnex = true;
    this.Annex_fa_id = row.row.id;
    this.getFileList(row.row.id);
  }
  public async getCompensation() {
    const res: any = await getPiClaimType();
    this.searchForm[3].options = res;
  }
  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[1].options = res;
  }

  private async getClaimReason() {
    const res: any = await getClaimReason();
    this.searchForm[4].options = res;
  }

  private async getDeductionMethod() {
    this.searchForm[5].options = await getDeductionMethod() as any;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private handleClaimDet(row) {
    (this.$refs["claimFormDetail"] as ClaimFormDetail).openDialog(row.row.id);
  }

  private async handleDeleteFiles(row) {
    let params = {
      fileIds: [row.row.id],
    };
    await deleteClaimFile(params);
    this.getFileList(this.Annex_fa_id);
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const { total, list }: any = await claimDetail(params);
    this.loading = false;
    this.table.total = +total;
    this.table.list = list;
  }

  private async handledownloadClaimFormxlsx() {
    if (this.selectedRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "至少选择一行数据！",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.selectedRows.map(async (item) => {
      await this.downloadClaimFormInfo(item.id, item.code);
    });
  }

  private async handledownloadClaimFormInfo(row) {
    await this.downloadClaimFormInfo(row.row.id, row.row.code);
  }

  private async downloadClaimFormInfo(id, claimNumber) {
    const res: any = await downloadClaimFormInfo(id);
    this.exportClaimFormInfoFunc(res, claimNumber);
  }

  // 导出excel
  private isExporting = false;

  private handleGeneral(row) {
    (this.$refs["editClaimForm"] as EditClaimForm).openDialog(row.row.id, false);
  }

  private handleEdit(row) {
    (this.$refs["editClaimForm"] as EditClaimForm).openDialog(row.row.id, true);
  }

  private handleDeductionToFa(row) {
    this.$confirm(row.row.status, "提示", {
      confirmButtonText: "抵扣详情",
      cancelButtonText: "强制核销",
      distinguishCancelAndClose: true,
      type: "success",
    })
      .then(async (e) => {
        // 抵扣详情
        this.handleDeduction(row);
      })
      .catch(async (err) => {
        if (err === "cancel") {
          await this.handleVerification(row.row);
        }
      });
  }

  private handleDeductionToQa(row) {
    this.$confirm(row.row.status, "提示", {
      confirmButtonText: "抵扣详情",
      cancelButtonText: "核销详情",
      distinguishCancelAndClose: true,
      type: "success",
    })
      .then(async (e) => {
        // 抵扣详情
        this.handleDeduction(row);
      })
      .catch(async (err) => {
        if (err === "cancel") {
          // 核销详情
          const res: any = await getWriteOffDetails(row.row.id);
          this.HXDetailsInfo.olaAmount = res.claimAmount;
          this.HXDetailsInfo.Amount = res.writeOffAmount;
          this.HXDetailsInfo.remark = res.writeOffReason;
          this.showHXDetails = true;
        }
      });
  }

  public exportClaimFormInfoFunc(list, claimNumber) {
    this.isExporting = true;
    // let table = this.exportClaimFormInfoHeader.slice(0, this.exportClaimFormInfoHeader.length - 1);
    let table = this.exportClaimFormInfoHeader;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      // `产品清单-${new Date()}`
      `${claimNumber}-产品清单`
    );
    this.isExporting = false;
  }

  // 导出
  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `索赔单管理-${new Date()}`
    );
    this.isExporting = false;
  }

  public handleVerification(item) {
    this.selectedItem = item;
    this.showVer = true;
  }

  private handleSuccess() {
    this.selectedRows = [];
    this.getList();
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      };
      await updateClaimRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[4].options = res;
  }

  public querySearch(data) {
    if (data?.claimReason) {
      data.claimReason = data.claimReason[1];
    }
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.createTimeStart = time[0];
      rest.createTimeEnd = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  public selectedItem = {} as any;

  private async abolished(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await abolished(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
    this.getList();
  }

  private async handleDeduction(row) {
    this.loading = true;
    await getDeductionDetails(row.row.id).then((res:any) => {
      this.DeductionList = res;
      this.showDeductionInfo = true;
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private selectedRows = [] as any;

  private onSelectionChange(rows) {
    this.selectedRows = rows;
  }
}
